import { AppStateFailure, IStateSlice } from '@symphony-solo/shared/common-state/src';
import { ChildDeliveryLocation, DeliveryLocationData, Table } from '@symphony-solo/domain/choose-location/src';
import { Order, OrderDetails, PaymentSessionCreate, OrderHistory, TimeSlot, OrderLocation, CustomerInfo, OrderItem } from '../models';
import { PaymentSessionRetrieve } from '../models/paymentRetrieve.model';

export class OrderState implements IStateSlice {
  public isLoading: boolean;
  public isApplyingDiscount: boolean;
  public failures: AppStateFailure;
  public order: Order[];
  public discountResponse: any;
  public orderverified: Object;
  public orderDetails: OrderDetails;
  public paymentSessionRetrieve: PaymentSessionRetrieve;
  public subTotal: number;
  public paymentSessionCreate: PaymentSessionCreate;
  public orderHistory: OrderHistory;
  public completedOrderId: number;
  public periodId: number;
  public orderLocation: OrderLocation;
  public isLocationDeliverOrder: boolean;
  public accountID: number;
  public orderID: number;
  public timeSlot: TimeSlot;
  public deliveryLocation: DeliveryLocationData;
  public childDeliveryLocation: ChildDeliveryLocation;
  public table: Table;
  public orderCompletedOn: string;
  public guestCheckoutOrderID: number;
  public customerInfo: CustomerInfo;
  public orderItems: OrderItem[];
  public reOrderItems: OrderItem[];
  public paymentSessionIntent: string;
  public notes: string;

  constructor() {
    this.isLoading = false;
    this.failures = null;
    this.order = [];
    this.discountResponse = null;
    this.orderverified = null;
    this.orderDetails = null;
    this.paymentSessionCreate = null;
    this.paymentSessionIntent = null;
    this.subTotal = null;
    this.orderHistory = null;
    this.completedOrderId = null;
    this.periodId = null;
    this.orderLocation = null;
    this.accountID = -1;
    this.orderID = -1;
    this.timeSlot = null;
    this.deliveryLocation = null;
    this.childDeliveryLocation = null;
    this.table = null;
    this.orderCompletedOn = null;
    this.guestCheckoutOrderID = 0;
    this.orderItems = [];
    this.reOrderItems = [];
    this.notes = null;
  }
}
